import { makeAutoObservable, toJS } from "mobx";
import axios from "axios";
import { apiV3Path, req } from "./api.config";
import FilterData from "./FilterData";
import User from "./User";
import config from "../config.json";
import Msg from "./Msg";
import RolesState from "./RolesState";
import nameAlias from "../state/name.alias";
import appState from "../state/app.state";
import stateRegion from "../state/state.region";
import { runInAction } from "mobx";
import ReportData from "./ReportData";
import AlertData from "./AlertData";
import {
  clearAuthStorage,
  getStoredUser,
  persistUser,
} from "../utils/auth.utils";
import { managerFioPlain } from "../utils/subscriptionAlertUtils";
import { normalizeSubscriptionMaxPeriod } from "../utils/reportManagerFilterUtils";
import { mergeClientLkUserIntoPayload } from "../utils/clientLkUsersUtils";
import { normalizeEventTotalsMessage } from "../utils/eventTotalsSaUtils";
import { listMyDashboardEntities } from "../utils/myCompaniesDashboardUtils";

class getData {
  // Адресс для тестов
  url_server = config.url_api;
  // Переменные авторизации
  isLoadPage = false;
  isAuth = Boolean(getStoredUser());
  noRight = false;
  //
  user = null; // Авторизованный пользователь
  user_profile = null; // Профиль авторизованного
  sizeItem = 2000; // Выгружать элементов
  isLoading = true; //Флаг загрузки списка
  employees = null; // Список сотрудников
  employees_dates = []; // Список сотрудников
  companys = null; //Список компаний
  /** Дашборд «Мои компании» — отдельно от companys/datas (GET company?users_id&support_users_id) */
  myDashboardCompanies = null;

  create_company_pass = false; // Флаг успешно созданной компании
  softs = []; //Список софта
  soft_type = []; // Получение имени СОФТа
  data_soft = []; // Изначальные данные списка софта

  company = {
    company: {
      inn: null,
    },
    clients_soft: null,
    clients_soft_data: null,
    licensing: null,
    licensing_info: null,
    licensing_free: null,
    company_mark_category: null,
    productions: null,
    this_production: null,
  };

  datas = null; // Изначальные данные списка компаний и сотрудников
  employee = null;
  licensing_all = []; // Массив со всеми лицензиями
  licensing_all_data = []; // Массив со всеми лицензиями
  soft_all = []; // Массив со всем софтом
  soft_all_data = []; // Массив со всем софтом
  test_array = [];
  // Переменные дизайна
  this_client_soft_id = ""; // id клиента рабочего места
  // Отчёты
  report_lic_activ_error = []; // Массивы для ошибок
  report_lic_activ_error_data = []; // Массивы для ошибок
  report_graph_all = []; // Отчёт по графикам общий
  report_graph_company = [];
  // Флаги
  observableReportLic = false; // Флаг прогрузки лицензий по всем компаниям
  observableReportAll = true; // Флаг прогрузки графиков по всем компаниям
  observableReportCompany = true; // Флаг прогрузки графиков компани
  // observableSoftAll = true; // Флаг прогрузки графиков по всем
  // Подписки
  subscription = null;
  subscription_data = null;
  min_subscription = 0;
  max_subscription = 30;
  // Центр оповещений
  alert_subscription = [];
  // Категории маркированной продукции компании
  companyCategoryLoadSeq = 0;
  partnerLinks = [];
  partnerLinksCompanyId = null;
  /** true: список связей недоступен (нет права или 403), не путать с пустым списком */
  partnerLinksForbidden = false;

  clientCompanyPartners = [];
  clientCompanyPartnersCompanyId = null;
  clientCompanyPartnersForbidden = false;

  clientLkUsersCompanyId = null;
  clientLkUsersPayload = null;
  clientLkUsersLoading = false;
  clientLkUsersForbidden = false;
  clientLkUsersError = false;
  clientLkLastDefaultPassword = null;

  // регион

  constructor() {
    makeAutoObservable(this);
  }

  setParameters = (name, value) => {
    runInAction(() => {
      this[`${name}`] = value;
    });
  };
  setParametersCompany = (name, value, boolean) => {
    if (!boolean) {
      this.company.company[`${name}`] = value;
    } else {
      this.company[`${name}`] = value;
    }
  };

  syncCompanyInLists = (companyId, patch) => {
    runInAction(() => {
      const apply = (list) => {
        if (!Array.isArray(list)) return;
        const idx = list.findIndex((c) => c.id === companyId);
        if (idx >= 0) {
          list[idx] = { ...list[idx], ...patch };
        }
      };
      apply(this.companys);
      apply(this.datas);
      apply(this.myDashboardCompanies);
    });
  };

  loadMyDashboardCompanies = async () => {
    if (!RolesState.companys && !RolesState.company_partners) {
      runInAction(() => {
        this.myDashboardCompanies = [];
      });
      return;
    }
    const userId = User.user?.id;
    if (userId == null) {
      runInAction(() => {
        this.myDashboardCompanies = [];
      });
      return;
    }
    const list = await this.fetchCompanyList({
      size: this.sizeItem,
      users_id: userId,
      support_users_id: userId,
    });
    runInAction(() => {
      this.myDashboardCompanies = Array.isArray(list) ? list : [];
    });
  };

  get showMyCompaniesNav() {
    if (!RolesState.companys && !RolesState.company_partners) {
      return false;
    }
    if (this.myDashboardCompanies === null) {
      return false;
    }
    return (
      listMyDashboardEntities(this.myDashboardCompanies, User.user?.id).length >
      0
    );
  }

  getCompanyPartners = async (companyId) => {
    const finish = (links, forbidden) => {
      runInAction(() => {
        this.partnerLinks = links;
        this.partnerLinksCompanyId = companyId;
        this.partnerLinksForbidden = forbidden;
      });
    };

    if (!RolesState.company_partners) {
      finish([], true);
      return false;
    }

    try {
      const res = await req(`company/${companyId}/partner_clients`, {
        suppressNoRight: true,
      });
      if (res.status === 200) {
        const data = res.data?.data ?? [];
        finish(Array.isArray(data) ? data : [], false);
        return true;
      }
    } catch (e) {
      console.error(e);
      const forbidden = e?.response?.status === 403;
      finish([], forbidden);
      return false;
    }
    finish([], false);
    return false;
  };

  getClientCompanyPartners = async (companyId) => {
    const finish = (links, forbidden) => {
      runInAction(() => {
        this.clientCompanyPartners = links;
        this.clientCompanyPartnersCompanyId = companyId;
        this.clientCompanyPartnersForbidden = forbidden;
      });
    };

    if (!RolesState.company_partners) {
      finish([], true);
      return false;
    }

    try {
      const res = await req(`company/${companyId}/partners`, {
        suppressNoRight: true,
      });
      if (res.status === 200) {
        const data = res.data?.data ?? [];
        finish(Array.isArray(data) ? data : [], false);
        return true;
      }
    } catch (e) {
      console.error(e);
      const forbidden = e?.response?.status === 403;
      finish([], forbidden);
      return false;
    }
    finish([], false);
    return false;
  };

  createPartnerLink = async (partnerCompanyId, clientCompanyId) => {
    try {
      const res = await req.post("company/partner_links", {
        partner_company_id: partnerCompanyId,
        client_company_id: clientCompanyId,
      });
      if (res.status === 200) {
        await this.getCompanyPartners(partnerCompanyId);
        return true;
      }
    } catch (e) {
      console.error(e);
    }
    return false;
  };

  updatePartnerLink = async (linkId, body) => {
    try {
      const res = await req.patch(`company/partner_links/${linkId}`, body);
      if (res.status === 200) {
        runInAction(() => {
          const idx = this.partnerLinks.findIndex((l) => l.link_id === linkId);
          if (idx >= 0 && body?.is_active !== undefined) {
            this.partnerLinks[idx] = {
              ...this.partnerLinks[idx],
              is_active: body.is_active,
            };
          }
        });
        return true;
      }
    } catch (e) {
      console.error(e);
    }
    return false;
  };
  // Сбросить isLoading
  isLoadingReset = async () => {
    this.isLoading = true;
  };

  logout = () => {
    clearAuthStorage();
    runInAction(() => {
      User.user = null;
      this.isAuth = false;
      this.noRight = false;
      this.myDashboardCompanies = null;
    });
  };

  // Авторизация
  getLogin = async (login, password, navigate) => {
    try {
      // report_lic_activ_error
      // report_lic_activ_error_data
      AlertData.setParameters("filter_collection", []);
      AlertData.setParameters("counter_error", 0);
      AlertData.setParameters("cls_visible_alert", "hidden");
      const res = await axios.post(`${this.url_server}auth`, {
        email: login,
        password: password,
      });
      if (res.status === 200) {
        if (!res.data.success) {
          return Msg.writeMessages(
            `Авторизация не удалась: ${res.data.message}`,
          );
        }

        const user = res.data.data;
        if (!user || typeof user.access_token !== "string") {
          this.logout();
          return Msg.writeMessages(
            "Авторизация не удалась: сервер не передал токен.",
          );
        }

        const t = user.access_token.replace(/..$/, "");
        const k = String(user.access_token.match(/..$/));
        const r = appState.r();
        localStorage.setItem("at", appState.e(t));
        localStorage.setItem("k", appState.e(k + r));
        localStorage.setItem("version_app", config.version_app);
        persistUser(user);
        User.user = getStoredUser();
        this.isAuth = true;
        await RolesState.readRight();
        Msg.resetMessages();
        if (RolesState.companys) {
          return navigate("/company");
        }
        if (RolesState.company_partners) {
          return navigate("/partners");
        }
        if (RolesState.emploees) {
          return navigate("/employees");
        }
        if (RolesState.all_soft_client || RolesState.subscription_rights) {
          return navigate("/allreport");
        }
        if (RolesState.admin_panel) {
          return navigate("/adminpanel");
        }
        return navigate("/noright");
      }
    } catch (e) {
      console.error(e);
      if (e.code === "ERR_NETWORK") {
        return Msg.writeMessages("Ошибка: " + e.message + " Попробуйте позже.");
      }
      this.logout();
    }
  };
  // Регистрация
  getRegistration = async (
    password,
    firstName,
    lastName,
    fatherName,
    email,
    phone,
  ) => {
    await req.post("user", {
      password: password,
      first_name: firstName,
      last_name: lastName,
      father_name: fatherName,
      email: email,
      phone: phone,
    });
  };
  // КОМПАНИИ
  saveThisCompany = async (company) => {
    this.company.company = company;
  };
  fetchCompanyList = async (query = {}) => {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.set(key, String(value));
      }
    });
    const qs = params.toString();
    const path = qs ? `company?${qs}` : "company";
    try {
      const res = await req(path);
      if (res.status === 200) {
        return res.data["data"]["request"];
      }
    } catch (e) {
      console.error(e);
    }
  };

  // get запрос на получение списка компаний
  getDataCompanys = async () => {
    if (!RolesState.companys && !RolesState.company_partners) return;
    try {
      const list = await this.fetchCompanyList({ size: this.sizeItem });
      if (list !== undefined) {
        runInAction(() => {
          this.companys = list;
          this.datas = list;
          this.isLoading = true;
          this.isAuth = true;
          this.isLoadPage = false;
        });
      }
      return true;
    } catch (e) {
      console.error(e);
    }
  };
  // Фильтр по компания
  filterDatas = async (search) => {
    if (search.length > 1) {
      const q = search.toLowerCase();
      runInAction(() => {
        return (this.datas = this.companys.filter((c) => {
          const managerFio = managerFioPlain(c.manager);
          const supportFio = managerFioPlain(c.support_manager);
          return (
            c.inn.toLowerCase().includes(q) ||
            c.name_company.toLowerCase().includes(q) ||
            managerFio.toLowerCase().includes(q) ||
            supportFio.toLowerCase().includes(q)
          );
        }));
      });
    } else {
      runInAction(() => {
        if (this.companys !== null) {
          return (this.datas = [...this.companys]);
        }
      });
    }
  };

  createClientLicensing = async () => {
    const canLoadSoft = RolesState.soft_company_id || RolesState.license_id;
    if (!canLoadSoft) {
      return;
    }
    try {
      if (RolesState.license_id) {
        await this.getLicensing();
      }
      await this.getClientsLicensing();
      if (
        RolesState.license_id &&
        Array.isArray(this.company.licensing) &&
        Array.isArray(this.company.clients_soft)
      ) {
        this.overkillSoftClients();
      } else if (Array.isArray(this.company.clients_soft)) {
        runInAction(() => {
          FilterData.sortFuncSoftVersionAB(this.company.clients_soft);
          this.company.clients_soft_data = [...this.company.clients_soft];
        });
      }
    } catch (e) {
      console.error(e);
      runInAction(() => {
        if (this.company.clients_soft === null) {
          this.company.clients_soft = [];
          this.company.clients_soft_data = [];
        }
      });
    }
  };
  resetClientLkUsers = () => {
    runInAction(() => {
      this.clientLkUsersCompanyId = null;
      this.clientLkUsersPayload = null;
      this.clientLkUsersLoading = false;
      this.clientLkUsersForbidden = false;
      this.clientLkUsersError = false;
      this.clientLkLastDefaultPassword = null;
    });
  };

  applyClientLkMutationResult = (companyId, user, defaultResetPassword) => {
    runInAction(() => {
      this.clientLkUsersCompanyId = companyId;
      this.clientLkUsersPayload = mergeClientLkUserIntoPayload(
        this.clientLkUsersPayload,
        user,
        companyId,
      );
      if (defaultResetPassword != null && defaultResetPassword !== "") {
        this.clientLkLastDefaultPassword = String(defaultResetPassword);
      }
    });
  };

  registerClientLkSuperuser = async (companyId, body) => {
    if (!companyId) {
      return null;
    }
    try {
      const res = await req.post(
        `personal_account/companies/${companyId}/client_lk_superuser`,
        body,
      );
      if (res.status === 200 && res.data?.success) {
        const user = res.data.data?.user;
        const defaultResetPassword = res.data.data?.default_reset_password;
        if (user) {
          this.applyClientLkMutationResult(
            companyId,
            user,
            defaultResetPassword,
          );
        }
        return { user, default_reset_password: defaultResetPassword };
      }
    } catch (e) {
      console.error(e);
    }
    return null;
  };

  resetClientLkUserPassword = async (companyId, userId) => {
    if (!companyId || !userId) {
      return null;
    }
    try {
      const res = await req.post(
        `personal_account/companies/${companyId}/users/${userId}/client_lk_reset_password`,
      );
      if (res.status === 200 && res.data?.success) {
        const user = res.data.data?.user;
        const defaultResetPassword = res.data.data?.default_reset_password;
        if (user) {
          this.applyClientLkMutationResult(
            companyId,
            user,
            defaultResetPassword,
          );
        }
        return {
          user,
          default_reset_password: defaultResetPassword,
          message: res.data.message,
        };
      }
    } catch (e) {
      console.error(e);
    }
    return null;
  };

  getClientLkUsers = async (companyId) => {
    if (!companyId) {
      return null;
    }
    if (
      this.clientLkUsersCompanyId === companyId &&
      this.clientLkUsersPayload !== null
    ) {
      return this.clientLkUsersPayload;
    }

    runInAction(() => {
      this.clientLkUsersLoading = true;
      this.clientLkUsersForbidden = false;
      this.clientLkUsersError = false;
    });

    try {
      const res = await req.get(
        `personal_account/companies/${companyId}/client_lk_users`,
        { suppressNoRight: true },
      );
      if (res.status === 200 && res.data?.success) {
        const data = res.data.data ?? null;
        runInAction(() => {
          this.clientLkUsersCompanyId = companyId;
          this.clientLkUsersPayload = data;
          this.clientLkUsersLoading = false;
        });
        return data;
      }
    } catch (e) {
      runInAction(() => {
        this.clientLkUsersLoading = false;
        if (e.response?.status === 403) {
          this.clientLkUsersForbidden = true;
        } else if (e.code !== "ERR_CANCELED" && e.name !== "CanceledError") {
          this.clientLkUsersError = true;
        }
      });
    }
    return null;
  };

  // get запрос на получение текущей компании
  getDataCompanyCard = async (inn) => {
    try {
      runInAction(() => {
        this.noRight = false;
        this.isLoading = true;
        this.company.company = null;
        this.resetClientLkUsers();
        this.clientCompanyPartners = [];
        this.clientCompanyPartnersCompanyId = null;
        this.clientCompanyPartnersForbidden = false;
      });
      const res = await req(`company/${inn}`);
      if (res.status === 200) {
        console.log(res.data["data"]);
        runInAction(() => {
          this.company.company = res.data["data"];
          if (RolesState.soft_company_id || RolesState.license_id) {
            this.company.clients_soft = null;
            this.company.clients_soft_data = null;
          }
        });
        // if (res.data.data.subscription_rel.length !== 0) {
        //   const today = new Date();
        //   const resValidSubscription = new Date(
        //     res.data.data.subscription_rel[0].validity_date
        //   );

        //   // if (today.getDate() > resValidSubscription.getDate()) {
        //   //   this.company.company.subscription_rel = [];
        //   // }
        // }

        const loadedCompany = this.company.company;
        if (
          loadedCompany?.is_partner &&
          loadedCompany.id &&
          RolesState.company_partners
        ) {
          runInAction(() => {
            this.company.productions = [];
            if (this.partnerLinksCompanyId !== loadedCompany.id) {
              this.partnerLinksCompanyId = null;
              this.partnerLinks = [];
              this.partnerLinksForbidden = false;
            }
          });
          await this.getCompanyPartners(loadedCompany.id);
        } else {
          runInAction(() => {
            this.partnerLinks = [];
            this.partnerLinksCompanyId = null;
          });
          if (RolesState.production_id) {
            await this.getProduction();
          }
        }
        if (!loadedCompany?.is_partner) {
          await this.createClientLicensing();
        } else {
          runInAction(() => {
            this.company.licensing = [];
            this.company.licensing_free = [];
            this.company.licensing_info = null;
            if (!RolesState.soft_company_id) {
              this.company.clients_soft = [];
              this.company.clients_soft_data = [];
            }
          });
          if (RolesState.soft_company_id) {
            await this.createClientLicensing();
          }
        }
        await this.getCompanyCategory(inn);
        if (loadedCompany?.id) {
          await this.getClientLkUsers(loadedCompany.id);
          await this.getClientCompanyPartners(loadedCompany.id);
        }
        runInAction(() => {
          this.isLoading = false;
        });
        return true;
      }
    } catch (e) {
      console.error(e);
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };
  getCompanyCategory = async (inn) => {
    const seq = ++this.companyCategoryLoadSeq;
    const requestInn = String(inn);
    try {
      runInAction(() => {
        if (seq === this.companyCategoryLoadSeq) {
          this.company.company_mark_category = [];
        }
      });
      const res = await req(`reports/markirovka?inn_company=${inn}`, {
        suppressNoRight: true,
      });
      if (seq !== this.companyCategoryLoadSeq) return;
      if (String(this.company.company?.inn) !== requestInn) return;

      const messages = Array.isArray(res.data?.message) ? res.data.message : [];
      const rawGroups = messages.flatMap((m) =>
        Array.isArray(m?.productGroups) ? m.productGroups : [],
      );
      const seen = new Set();
      const categories = [];
      rawGroups.forEach((group) => {
        const resolved = nameAlias.resolveMarkingProductGroup(group);
        if (!resolved || seen.has(resolved.abb_name)) return;
        seen.add(resolved.abb_name);
        categories.push(resolved);
      });

      runInAction(() => {
        if (seq !== this.companyCategoryLoadSeq) return;
        if (String(this.company.company?.inn) !== requestInn) return;
        this.company.company_mark_category = categories;
      });
    } catch (e) {
      if (axios.isAxiosError(e)) {
        console.error(e);
      }
    }
  };
  // getDataCompanyCard = async () => {
  //   try {
  //     const res = await req(`company/${this.company.inn}`);
  //     this.company.company = res.data["data"];
  //     if (res) {
  //       if (RolesState.license_id) {
  //         // await this.getLicensing();
  //         // await this.getClientsLicensing();
  //       }
  //       if (RolesState.production_id) {
  //         await this.getProduction();
  //       }
  //       this.isLoading = false;
  //     }
  //   } catch (e) {
  //     console.error(e);
  //   }
  // };
  parseProductionListPayload = (data) => {
    const payload = data ?? {};
    return {
      request: Array.isArray(payload.request) ? payload.request : [],
      total_records: payload.total_records ?? 0,
      next_page: payload.next_page ?? 0,
      page: payload.page ?? 1,
      size: payload.size ?? 0,
    };
  };

  fetchProductionPage = async ({ page = 1, size = 100, signal } = {}) => {
    if (!User.user?.is_superuser) {
      return null;
    }
    try {
      const res = await req(`production/?size=${size}&number=${page}`, {
        signal,
        suppressNoRight: true,
      });
      if (res.status === 200) {
        return this.parseProductionListPayload(res.data?.data);
      }
    } catch (e) {
      if (e?.code !== "ERR_CANCELED" && e?.name !== "CanceledError") {
        console.error("fetchProductionPage", e);
      }
      throw e;
    }
    return null;
  };

  fetchAllProduction = async ({ size = 100, signal, onProgress } = {}) => {
    const all = [];
    let page = 1;
    let totalRecords = 0;

    while (true) {
      if (signal?.aborted) {
        throw new DOMException("Aborted", "AbortError");
      }
      const chunk = await this.fetchProductionPage({ page, size, signal });
      if (!chunk) {
        return { rows: all, total_records: totalRecords, error: "forbidden" };
      }
      all.push(...chunk.request);
      totalRecords = chunk.total_records || all.length;
      onProgress?.({
        loaded: all.length,
        total: totalRecords,
        page: chunk.page,
      });
      const next = chunk.next_page;
      if (!next || next === 0 || next === page) {
        break;
      }
      page = next;
    }

    return { rows: all, total_records: totalRecords, error: null };
  };

  fetchCompanyProductionPage = async (
    companyId,
    { page = 1, size = 2000, signal } = {},
  ) => {
    try {
      const res = await req(
        `production/${companyId}?size=${size}&number=${page}`,
        { signal, suppressNoRight: true },
      );
      if (res.status === 200) {
        return this.parseProductionListPayload(res.data?.data);
      }
    } catch (e) {
      if (e?.code !== "ERR_CANCELED" && e?.name !== "CanceledError") {
        console.error("fetchCompanyProductionPage", e);
      }
      throw e;
    }
    return null;
  };

  fetchCompanyProductionList = async (companyId, signal) => {
    const all = [];
    let page = 1;
    const size = this.sizeItem;

    while (true) {
      if (signal?.aborted) {
        throw new DOMException("Aborted", "AbortError");
      }
      const chunk = await this.fetchCompanyProductionPage(companyId, {
        page,
        size,
        signal,
      });
      if (!chunk) {
        break;
      }
      all.push(...chunk.request);
      const next = chunk.next_page;
      if (!next || next === 0 || next === page) {
        break;
      }
      page = next;
    }

    return all;
  };

  // Получение списка площадок компании
  getProduction = async () => {
    if (localStorage.getItem("User") === null) return;
    // this.observableProduction = true;
    if (
      User.user?.permission?.includes("get_production_id") ||
      User.user?.is_superuser
    ) {
      const res = await req(
        `production/${this.company.company.id}?size=${this.sizeItem}`,
      );
      if (res.status === 200) {
        runInAction(() => {
          this.company.productions = res.data["data"]["request"];
        });
        return true;
      }
    }
  };
  // Получение текущей площадки
  thisProduction = async (item_id) => {
    return (this.company.this_production = this.company.productions.find(
      (p) => p.id === item_id,
    ));
  };

  // Создание новой компании
  newCompany = async (dt) => {
    try {
      const res = await req.post("company", dt);
      if (res.status === 200) {
        this.updateFlagCreateCompany(true);
      }
    } catch (e) {
      console.error("newCompany", e);
    }
  };

  updateFlagCreateCompany = async (bollean) => {
    this.create_company_pass = bollean;
  };
  // Редактирование текущей компании
  updateCompany = async (dataCompany) => {
    try {
      const res = await req.patch(
        `company/${this.company.company.id}`,
        dataCompany,
      );
      if (res.status === 200) {
        return true;
      }
    } catch (e) {
      console.error(e);
    }
  };

  assignManager = async (companyId, usersId) => {
    try {
      const res = await req.patch(`company/assign_manager/${companyId}`, {
        users_id: usersId,
      });
      if (res.status === 200) {
        const user =
          this.employees_dates?.find((u) => u.id === usersId) ||
          res.data?.data?.request;
        if (user) {
          const manager = {
            first_name: user.first_name,
            last_name: user.last_name,
            father_name: user.father_name,
            id: user.id,
            email: user.email,
            phone: user.phone,
            role_rel: user.role_rel,
            is_active: user.is_active,
            is_superuser: user.is_superuser,
          };
          runInAction(() => {
            this.setParametersCompany("manager", manager);
          });
        }
        void this.loadMyDashboardCompanies();
        return true;
      }
    } catch (e) {
      console.error("assignManager", e);
    }
  };

  assignSupportManager = async (companyId, usersId) => {
    try {
      const res = await req.patch(
        `company/assign_support_manager/${companyId}`,
        { users_id: usersId },
      );
      if (res.status === 200) {
        const user =
          this.employees_dates?.find((u) => u.id === usersId) ||
          res.data?.data?.request;
        if (user) {
          const supportManager = {
            first_name: user.first_name,
            last_name: user.last_name,
            father_name: user.father_name,
            id: user.id,
            email: user.email,
            phone: user.phone,
            role_rel: user.role_rel,
            is_active: user.is_active,
            is_superuser: user.is_superuser,
          };
          runInAction(() => {
            this.setParametersCompany("support_manager", supportManager);
          });
        }
        void this.loadMyDashboardCompanies();
        return true;
      }
    } catch (e) {
      console.error("assignSupportManager", e);
    }
  };

  // Получение списка регионов (get_country / get_filter_country)
  getListCountry = async () => {
    const canLoad =
      RolesState.checkRight("get_country") ||
      RolesState.checkRight("get_filter_country");
    if (!canLoad) {
      return;
    }
    try {
      const res = await req("country", { suppressNoRight: true });
      if (res.status === 200) {
        stateRegion.setParameters("collectionRegion", res.data.data.response);
      }
    } catch (e) {
      if (e?.response?.status !== 403) {
        console.error(e);
      }
    }
  };
  // Редактирование текущей площадки
  updateProduction = async (dataProduction) => {
    const res = await req.patch(
      `production/${this.company.this_production.id}`,
      dataProduction,
    );
    if (res.status === 200) {
      const productionID = this.company.productions.find(
        (p) => p.id === this.company.this_production.id,
      );
      if (productionID) {
        productionID.name_production = dataProduction.name_production;
        productionID.address_production = dataProduction.address_production;
        productionID.contact_representative =
          dataProduction.contact_representative;
        productionID.phone = dataProduction.phone;
        productionID.coordinats = dataProduction.coordinats;
      }
      return true;
    }
  };
  // Cоздание новой площадки площадки
  addProduction = async (dataProduction) => {
    const res = await req.post("production", dataProduction);
    if (res.status === 200) {
      await this.getProduction();
    }
  };
  // Cоздание новой площадки площадки
  removeProduction = async () => {
    const res = await req.delete("production", {
      data: {
        id: [this.company.this_production.id],
      },
    });
    if (res.status === 200) {
      const resProduction = await this.getProduction();
      if (resProduction) {
        return true;
      }
    }
  };
  // Редактирование количество юр. лиц
  updateUrNumber = async (number) => {
    try {
      const res = await req.patch(`company/${this.company.company.id}`, {
        number_company: Number(number),
      });

      if (res.status === 200) {
        this.setParametersCompany("number_company", number);
        return true;
      }
    } catch (e) {
      console.error(e);
    }
  };
  // СОФТ
  getClientSoft = async (client) => {
    try {
      this.this_client_soft_id = this.company.clients_soft.find(
        (cl) => cl.client_id === client.client_id,
      );
    } catch (e) {
      console.error(e);
    }
  };
  // СОТРУДНИКИ
  getDataEmployees = async (no_right) => {
    if (localStorage.getItem("User") === null) return;
    try {
      let res = null;
      if (!no_right) {
        res = await req(`user`);
      } else {
        res = await req(`user/directory`);
      }
      if (res.status === 200) {
        runInAction(() => {
          this.employees = res.data["data"]["request"];
          this.employees_dates = res.data["data"]["request"];
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  getPersone = async (url_api) => {
    try {
      if (RolesState.all_roles) {
        await User.allRole();
      }
      const res = await req(url_api);
      if (res.status === 200) {
        runInAction(() => {
          this.employee = res.data?.data ?? res.data;
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  // Редактирование карточки сотрудника
  editPerson = async (dataPersone) => {
    try {
      const res = await req.patch(`user/${this.employee.id}`, dataPersone);
      if (res.status === 200) {
        await this.getPersone(`user/${this.employee.id}`);
      }
    } catch (e) {
      console.error(e);
    }
  };
  // Сбросить пароль сотруднику
  resetPass = async () => {
    const res = await req.patch("user/reset_password", {
      id: this.employee.id,
    });
    if (res.status === 200) {
      Msg.writeMessages("Установлен пароль по умолчанию - 123451234568");
    }
  };

  // Получение профиля юзера
  getUser = async () => {
    try {
      const res = await req(`my_profile/`);
      if (res.status === 200) {
        runInAction(() => {
          this.user_profile = res.data.data;
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
  // Редактирование профиля
  updateUser = async (dataUser) => {
    try {
      const res = await req.patch("my_profile", dataUser);
      if (res.status === 200) {
        this.user_profile = res.data["data"];
        User.setParameterUser("last_name", res.data.data.last_name);
        User.setParameterUser("first_name", res.data.data.first_name);
        User.setParameterUser("phone", res.data.data.phone);
        User.setParameterUser("father_name", res.data.data.father_name);
        persistUser(User.user);
        return res
      }
    } catch (e) {
      console.error(e);
    }
  };
  // Сменить пароль в профиле
  updatePasswordUser = async (password) => {
    try {
      const res = await req.patch("my_profile/change_password", {
        password: String(password),
      });
      if (res.status === 200) {
        Msg.writeMessages("Пароль изменён");
      }
    } catch (e) {
      console.error(e);
    }
  };
  // Лицензии
  // Получение клиент ид компании
  getClientsLicensing = async () => {
    const emptySoft = () => {
      runInAction(() => {
        this.company.clients_soft = [];
        this.company.clients_soft_data = [];
      });
    };
    try {
      const res = await req(
        `soft_client/${this.company.company.id}?size=${this.sizeItem}`,
        { suppressNoRight: true },
      );
      if (res.status === 200) {
        runInAction(() => {
          const request = res.data?.data?.request;
          const list = Array.isArray(request)
            ? request.filter(
                (element) => element["software_client_rel"] !== null,
              )
            : [];
          this.company.clients_soft = list;
          this.company.clients_soft_data = [...list];
        });
      } else {
        emptySoft();
      }
      return true;
    } catch (e) {
      console.error(e);
      emptySoft();
    }
  };
  // Получение лицензий компании
  getLicensing = async () => {
    try {
      const res = await req(
        `licensing/search/${this.company.company.id}?size=${this.sizeItem}`,
        { suppressNoRight: true },
      );
      if (res.status === 200) {
        runInAction(() => {
          const activ = res.data?.data?.activ_license;
          const noActiv = res.data?.data?.no_activ;
          this.company.licensing = [
            ...(Array.isArray(activ) ? activ : []),
            ...(Array.isArray(noActiv) ? noActiv : []),
          ];
          const free = res.data?.data?.free_license;
          this.company.licensing_free = Array.isArray(free) ? free : [];
          this.company.licensing_info = res.data?.data?.counters ?? null;
        });
        return true;
      }
    } catch (e) {
      console.error(e);
      runInAction(() => {
        this.company.licensing = [];
        this.company.licensing_free = [];
        this.company.licensing_info = null;
      });
    }
  };

  fetchLicensingSearchPage = async (companyId, size = this.sizeItem) => {
    const emptyPayload = {
      total_records: 0,
      counters: { count_activ: 0, count_free: 0, no_activ: 0 },
      free_license: [],
      activ_license: [],
      no_activ: [],
      next_page: 0,
      page: 1,
      size,
    };
    const id = companyId ?? this.company?.company?.id;
    if (!id) {
      return emptyPayload;
    }
    try {
      const res = await req(`licensing/search/${id}?size=${size}`, {
        suppressNoRight: true,
      });
      if (res.status === 200) {
        const data = res.data?.data ?? {};
        return {
          total_records: data.total_records ?? 0,
          counters: {
            count_activ: data.counters?.count_activ ?? 0,
            count_free: data.counters?.count_free ?? 0,
            no_activ: data.counters?.no_activ ?? 0,
          },
          free_license: Array.isArray(data.free_license)
            ? data.free_license
            : [],
          activ_license: Array.isArray(data.activ_license)
            ? data.activ_license
            : [],
          no_activ: Array.isArray(data.no_activ) ? data.no_activ : [],
          next_page: data.next_page ?? 0,
          page: data.page ?? 1,
          size: data.size ?? size,
        };
      }
    } catch (e) {
      console.error(e);
    }
    return emptyPayload;
  };

  // Перебор клиентов и лицензий
  overkillSoftClients = () => {
    if (
      !Array.isArray(this.company.clients_soft) ||
      !Array.isArray(this.company.licensing)
    ) {
      return;
    }
    const enrichClient = (cl) => {
      const clientLic = this.company.licensing.find(
        (l) => l.software_client_id === cl.client_id,
      );
      if (clientLic) {
        if (clientLic.type_software === "old") {
          cl.valid_period_days = "Обновите";
        } else {
          const this_d = new Date().getFullYear();
          if (new Date(clientLic.activ_data).getFullYear() - this_d) {
            cl.activ_data = "Бессрочно";
          }
          if (clientLic.valid_period_days < 1) {
            cl.valid_period_days = "Истекла";
          } else if (clientLic.valid_period_days > 3650) {
            cl.valid_period_days = "Бессрочная";
          } else {
            cl.valid_period_days = clientLic.valid_period_days;
          }
        }
        cl.activ_data = clientLic.activ_data;
        if (clientLic.is_activ) {
          cl.activated = clientLic.is_activ;
        } else {
          cl.activated = "hold";
        }

        cl.id_license = clientLic.id_license;
        cl.type_software = clientLic.type_software;
      } else {
        cl.activ_data = "";
        cl.valid_period_days = "";
      }
    };

    this.company.clients_soft.forEach(enrichClient);
    if (Array.isArray(this.company.clients_soft_data)) {
      this.company.clients_soft_data.forEach(enrichClient);
    }
    FilterData.sortFuncSoftVersionAB(this.company.clients_soft);
    if (Array.isArray(this.company.clients_soft_data)) {
      FilterData.sortFuncSoftVersionAB(this.company.clients_soft_data);
    }
    FilterData.dayFilterLic();
  };
  // Получить весь софт
  getAllSoft = async (flag) => {
    if (this.soft_all.length === 0 || flag) {
      try {
        const res = await req(`soft_client?size=${9999}`);
        const d1 = new Date();
        if (res.status === 200) {
          runInAction(() => {
            this.soft_all = res.data["data"]["request"];
            this.soft_all_data = res.data["data"]["request"];
          });
          const d2 = new Date();
          const status = 200;
          return status;
        }
      } catch (e) {
        console.error(e);
      }
    }
  };
  // Получить все лицензии
  getAllLicensings = async () => {
    console.log("getAllLicensings 1");
    if (localStorage.getItem("User") === null) return;
    if (
      User.user?.permission?.includes("get_all_licensing") ||
      User.user?.is_superuser
    ) {
      console.log("getAllLicensings 2", this.licensing_all_data);

      try {
        const res = await req.get(`licensing?size=${9999}`);
        console.log("getAllLicensings 3 res", res);

        if (res.status === 200) {
          this.licensing_all = res.data["data"]["activ_license"];
          this.licensing_all_data = res.data["data"];
          return res;
        }
      } catch (e) {
        console.error(e);
      }
    }
  };
  // Таргет клиента софта
  getTargetClient = async () => {
    this.company.clients_soft.find(
      (cl) => cl.client_id === this.company.clients_soft.client_id,
    );
  };
  // Отвязать лицензию от клиента
  unlincLic = async () => {
    const res = await req.patch(`licensing/unlink`, {
      software_client_id: this.this_client_soft_id.client_id,
    });
    if (res.status === 200) {
      await this.createClientLicensing();
    }
  };

  // Привязать лицензию к клиенту
  attachLic = async () => {
    try {
      const res = await req.patch(
        `licensing/attach/${Number(FilterData.license.id_license)}`,
        {
          software_client_id: this.this_client_soft_id.client_id,
        },
      );
      if (res.status === 200) {
        await this.createClientLicensing();
      }
    } catch (e) {
      console.error(e);
    }
  };
  // Сгенерировать лицензии
  generationLicense = async (count, period, version, description) => {
    try {
      const res = await req.post(`licensing/generate`, {
        license: [
          {
            inn_company: String(this.company.company.inn),
            count: Number(count),
            period_action: Number(period),
            lite_version: version,
            description: description,
          },
        ],
      });
      if (res.status === 200) {
        await this.getLicensing();
      }
    } catch (e) {
      console.error(e);
    }
  };
  // Продлить лицензию

  renewalLic = async (period) => {
    try {
      const res = await req.patch(
        `licensing/prolongation/${FilterData.license.id_license}`,
        {
          period_prolongation: Number(period),
        },
      );
      if (res.status === 200) {
        await this.createClientLicensing();
      }
    } catch (e) {
      console.error(e);
    }
  };

  // Проверка лицензии
  checkLic = async (id_license) => {
    try {
      const res = await req.get(`licensing/pin/${id_license}`);
      if (res.status === 200) {
        Msg.writeMessages(
          JSON.stringify({
            Клиент: res.data["data"].software_client_id,
            "Активна до": res.data["data"].activ_data,
            Инфо:
              res.data["data"].type_software !== "old"
                ? res.data["data"].type_software
                : "Используется старая версия лицензи, необходимо обновить лицензию.",
            Комментарий: res.data["data"].description,
            Активность: res.data["data"].is_activ
              ? "активна "
              : "работа лицензии приостановлена",
          }),
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  // ОТЧЁТЫ

  // Отвязать клиента от компании
  deleteClientID = async (client) => {
    try {
      const res = await req.delete("licensing", {
        data: { client_id: client.client_id },
      });

      if (res.status === 200) {
        await this.getAllSoft(true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  getIntegration1cPrices = async (params = {}) => {
    try {
      const res = await req.get(apiV3Path("integrations/1c/prices"), {
        params,
      });
      if (res.status === 200 && res.data?.success) {
        return res.data?.data?.prices ?? [];
      }
      return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  };

  getCompanyInvoices = async (companyId, params = {}) => {
    try {
      const res = await req.get(
        apiV3Path("integrations/bitrix24/company-invoices"),
        {
          params: {
            company_id: companyId,
            ...params,
          },
        },
      );
      if (res.status === 200 && res.data?.success) {
        const data = res.data.data ?? {};
        return {
          invoices: data.invoices ?? [],
          total_records: data.total_records ?? 0,
          page: data.page ?? 1,
          size: data.size ?? params.size ?? 50,
        };
      }
      return null;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  getCompanyInvoiceLines = async (bitrixId, params = {}) => {
    try {
      const res = await req.get(
        apiV3Path(`integrations/bitrix24/company-invoices/${bitrixId}/lines`),
        { params },
      );
      if (res.status === 200 && res.data?.success) {
        const data = res.data.data ?? {};
        return {
          positions: data.positions ?? [],
          total: data.total ?? 0,
          page: data.page ?? 1,
          size: data.size ?? params.size ?? 50,
          bitrix_id: data.bitrix_id ?? bitrixId,
        };
      }
      return null;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  // Подписки
  postSubscription = async (obj) => {
    try {
      const res = await req.post(`subscription/`, obj);
      if (res.status === 200) {
        this.setParametersCompany("subscription_rel", [res.data.data]);
      }
    } catch (e) {
      console.error(e);
    }
  };
  prolongationSubscription = async (count) => {
    try {
      const res = await req.patch(
        `subscription/${this.company.company.subscription_rel[0].id}/prolongation`,
        {
          period_prolongation: count,
        },
      );
      if (res.status === 200) {
        this.company.company.subscription_rel[0].validity_date =
          res.data.data.activ_data;
      }
    } catch (e) {
      console.error(e);
    }
  };

  deleteSubscription = async () => {
    try {
      const res = await req.delete("subscription", {
        data: { id_subscription: this.company.company.subscription_rel[0].id },
      });
      if (res.status === 200) {
        this.setParametersCompany("subscription_rel", []);
      }
    } catch (e) {
      console.error(e);
    }
  };

  // Отчёт по подпискам
  allReportSubscription = async (parameter) => {
    try {
      if (
        !RolesState.get_subscription_id &&
        !User.user?.is_superuser &&
        !RolesState.subscription_rights
      )
        return;
      const url =
        typeof parameter === "number"
          ? `subscription/valid_subscription?max_period=${normalizeSubscriptionMaxPeriod(parameter)}&size=${this.sizeItem}`
          : parameter.replace(
              /max_period=([^&]+)/,
              (_, raw) => `max_period=${normalizeSubscriptionMaxPeriod(raw)}`,
            );
      const res = await req(url);
      if (res.status === 200) {
        if (res.data["data"].length === 0) {
          runInAction(() => {
            this.alert_subscription = [];
            this.subscription = [];
            this.subscription_data = [];
          });
          return;
        }
        if (res) {
          runInAction(() => {
            this.alert_subscription = res.data["data"]["request"];
            this.subscription = res.data["data"]["request"];
            this.subscription_data = res.data["data"]["request"];
          });
          return res.data.data.request;
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  // Деактивировать или активировать лицензию
  setActiveLicenseAndDisable = async (id_license, boolean) => {
    try {
      const res = await req.patch(`licensing/set_activity/${id_license}`, {
        is_activ: boolean,
      });
      if (res) {
        runInAction(() => {
          const licensingID = this.company.clients_soft.find(
            (l) => l.id_license === id_license,
          );
          if (licensingID) {
            licensingID.activated = boolean ? true : "hold";
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  selectMaxSubscription = async (period) => {
    this.max_subscription = normalizeSubscriptionMaxPeriod(period);
  };

  // Отчёт по старым лицензиям лицензиям

  // getAllReportLic = async (data) => {
  //   if (localStorage.getItem("User") === null) return;
  //   this.observableReportLic = true;
  //   if (
  //     User.user.permission.includes("get_all_licensing") ||
  //     User.user.is_superuser
  //   ) {
  //     try {
  //       // this.report_lic_activ_data = [];
  //       // this.report_lic_activ = [];
  //       // await this.hendlerValidLic(
  //       //   this.licensing_all,
  //       //   this.report_lic_activ,
  //       //   this.report_lic_activ_data,
  //       //   this.max_subscription
  //       // );
  //     } catch (e) {
  //       console.error(e);
  //     } finally {
  //       this.observableReportLic = false;
  //     }
  //   }
  // };

  // отчёт по сериализации и печати

  fetchEventTotalsSa = async ({
    filterdate,
    companyIds,
    event,
    limitPage,
  } = {}) => {
    try {
      const params = new URLSearchParams();
      if (filterdate?.[0]) {
        params.append("filterdate", filterdate[0]);
      }
      if (filterdate?.[1]) {
        params.append("filterdate", filterdate[1]);
      }
      if (Array.isArray(companyIds)) {
        companyIds.forEach((id) => {
          if (id != null && id !== "") {
            params.append("company_id", String(id));
          }
        });
      }
      if (event) {
        params.set("event", event);
      }
      if (limitPage != null && limitPage !== "") {
        params.set("limit_page", String(limitPage));
      }
      const qs = params.toString();
      const path = qs
        ? `reports/event_totals_sa?${qs}`
        : "reports/event_totals_sa";
      const res = await req(path);
      if (res?.data?.success && res.data.message) {
        return normalizeEventTotalsMessage(res.data.message);
      }
    } catch (e) {
      console.error(e);
      const status = e?.response?.status;
      if (status === 503 || status === 502 || status === 504) {
        Msg.writeMessages(
          "Сервис отчётов временно недоступен. Повторите запрос позже.",
        );
      }
    }
    return null;
  };

  // Отчёт по сериализации
}

export default new getData();
